import { ServiceRegistry } from "./ServiceRegistry";

let _instance: ServiceRegistry | null = null;

export function getServiceRegistry(): ServiceRegistry {
  if (!_instance) _instance = new ServiceRegistry();
  return _instance;
}

export function resetServiceRegistry() {
  _instance = null;
}
